import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { TINTA, MARCA, ACCION } from "../constants.js";

/* ============================================================
   ERROR BOUNDARY — aísla fallos de una vista para que NO tumben toda la app.
   Se envuelve por separado el Navegador y el Editor (ver S-013): una excepción
   en el Editor (p. ej. un trazo inválido) muestra aquí un mensaje con botón de
   reintentar, sin perder el resto de la app. Las capturas ya guardadas viven en
   IndexedDB y en el estado de App (fuera de este subárbol), así que se conservan.
   ============================================================ */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Se registra para diagnóstico; no se re-lanza (el boundary ya lo contuvo).
    console.error(
      `[revisor-web] Error contenido en ${this.props.nombre || "una vista"}:`,
      error,
      info?.componentStack
    );
  }

  reintentar = () => {
    this.setState({ error: null });
    this.props.alReiniciar?.();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="flex-1 min-h-0 flex items-center justify-center p-6">
          <div
            className="max-w-md w-full bg-white border rounded-2xl shadow-sm p-6 text-center"
            style={{ borderColor: "#E2E5EB" }}
          >
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3 text-white"
              style={{ background: MARCA }}
            >
              <AlertTriangle size={24} />
            </div>
            <p className="font-bold text-lg" style={{ color: TINTA }}>
              Algo falló en {this.props.nombre || "esta vista"}
            </p>
            <p className="text-sm mt-2" style={{ color: "#5B6472" }}>
              La vista se detuvo por un error, pero la aplicación sigue en pie y
              <b> tus capturas guardadas están a salvo</b>. Puedes reintentar.
            </p>
            <button
              onClick={this.reintentar}
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-white"
              style={{ background: ACCION }}
            >
              <RotateCcw size={16} /> Reintentar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
